import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/coupon/dyq26_detail.png'


const _withScopeId = n => (_pushScopeId("data-v-22a92acc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col pageDetail" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img class=\"detailTop\" src=\"" + _imports_0 + "\" data-v-22a92acc><div class=\"content\" data-v-22a92acc><div class=\"detailTitle\" data-v-22a92acc>电影消费券</div><div class=\"detailType\" data-v-22a92acc>领取时间</div><div class=\"detailContent\" data-v-22a92acc> 10月23日-10月25日。 </div><div class=\"detailType\" data-v-22a92acc>使用时间</div><div class=\"detailContent\" data-v-22a92acc> 10月23日-11月23日。 </div><div class=\"detailType\" data-v-22a92acc>消费规则</div><div class=\"detailContent\" data-v-22a92acc> 消费券面值20元，可根据实际需要叠加使用，消费券面值不足以抵扣电影票价部分由消费者自行付款，消费券累计超过电影票价部分不找零。 由于档期、放映厅等差异，各平台售价不一，各电影院自行提供参考票价，同步公布前台电话以供消费者咨询。 </div><div class=\"detailType\" data-v-22a92acc>使用规则</div><div class=\"detailContent\" data-v-22a92acc> 到电影院现场核销使用，一张电影票可叠加多张消费券，有效期在电影消费券页面注明，逾期未使用则作废。 </div></div>", 2)
const _hoisted_4 = { class: "fixBtn" }
const _hoisted_5 = { class: "btn_time" }
const _hoisted_6 = {
  key: 0,
  class: "btn btn_gray"
}
const _hoisted_7 = {
  key: 1,
  class: "btn btn_ready"
}
const _hoisted_8 = {
  key: 3,
  class: "btn btn_gray"
}
const _hoisted_9 = {
  key: 4,
  class: "btn btn_gray"
}
const _hoisted_10 = {
  key: 5,
  class: "btn btn_gray"
}
const _hoisted_11 = {
  key: 6,
  class: "btn btn_gray"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.detailDatas.startTimeInstruction), 1),
      (_ctx.detailDatas.dhStatus == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
        : (_ctx.detailDatas.dhStatus == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "即将开始"))
          : (_ctx.detailDatas.dhStatus == 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "btn btn_red",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getCouponKill && _ctx.getCouponKill(...args)))
              }, " 抢券中 "))
            : (_ctx.detailDatas.dhStatus == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 已抢完 "))
              : (_ctx.detailDatas.dhStatus == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 只可抢一张 "))
                : (_ctx.detailDatas.dhStatus == 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 活动已结束 "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, "不可重复抢券"))
    ])
  ]))
}